export function NotIncludedIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.2">
        <path
          d="M5 11H17"
          stroke="white"
          strokeWidth="2.2"
          strokeLinecap="round"
        />
      </g>
    </svg>
  )
}
